// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a9bc3b71","455":"7e7cfb51","977":"7c144d09"}[chunkId] + ".chunk.js";
};